import { isPeriodTag } from '../../period';

/**
 * @param {Object} state
 * @param {Object} input
 * @param {String} input.uuid
 * @returns {Object}
 */
export default function remove({ tags, categories }, { uuid }) {
  if (isPeriodTag(tags.map.get(uuid), categories)) {
    return null;
  }
  return {
    tags: {
      remove: [uuid],
    },
  };
}
